<template>
  <Container
    id="heading"
  >
    <HeroCard
      :heading="t('jc.view.help.hero.title')"
      :paragraph="t('jc.view.help.hero.text')"
      :image="{
        src: 'images/nature/hill_sunshine.png',
        alt: t('jc.view.help.hero.banner.alt'),
      }"
      :label="t('jc.view.help.hero.button.label')"
      :icon="{ prefix: 'fab', iconName: 'discord' }"
      :to="config.public.discordSupportUrl"
    />
  </Container>
</template>

<script setup lang="ts">
definePageMeta({
  nameKey: 'help',
})

const { t } = useI18n()
const config = useRuntimeConfig()
</script>
